<template>
  <div>
    <div v-if="importType === 1">
      <el-form
        ref="importDataForm"
        :model="importDataParam"
        size="small"
        label-position="top"
      >
        <!--运单号-->
        <el-form-item
          :label="$t('newOrder.waybillNumber') + '：'"
          prop="waybillNumbers"
          :rules="{
            required: true,
            message: this.$t('GlobalSetObj.inputWaybillNumber'),
            trigger: ['blur', 'change']
          }"
        >
          <el-input
            v-model="importDataParam.waybillNumbers"
            :placeholder="$t('GlobalSetObj.CanBeEnteredMultiple2000')"
            type="textarea"
            :rows="4"
          />
        </el-form-item>
        <!--损失类型-->
        <el-form-item
          :label="$t('newOrder.LossType') + '：'"
          prop="lossType"
          :rules="{
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }"
        >
          <el-select
            v-model="importDataParam.lossType"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="item in responsibilityTypeList.LossType"
              :key="item.key"
              :label="item.value"
              :value="Number(item.key)"
            />
          </el-select>
        </el-form-item>
        <!--责任网点-->
        <el-form-item
          :label="$t('fixDutyFine.ResponsibleBranch') + '：'"
          prop="siteId"
          :rules="{
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }"
        >
          <el-select
            v-model="importDataParam.siteId"
            :placeholder="this.$t('GlobalSetObj.pleaseChoose')"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="item in siteIdList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div v-else>
      <!--总共导入-->
      <span style="margin-right: 20px">{{ $t('receivablePayable.TotalImport') }}：{{ importData.totalCount }}</span>
      <!--导入成功-->
      <span style="margin-right: 20px">{{ $t('orderCenterCont.ImportWasSuccessful') }}：{{ importData.success }}</span>
      <!--导入失败-->
      <span>{{ $t('orderCenterCont.ImportFailed') }}：<span style="color: #DD4A68">{{ importData.fail }}</span></span>
      <div v-if="importData.fail > 0">
        <!--导入失败单号-->
        <div style="margin: 10px 0">
          {{ $t('fixDutyFine.ImportFailedOrderNumber') }}：
        </div>
        <div style="max-height: 300px;overflow-y: auto;">
          <div v-for="(item, index) in importData.failList" :key="index" style="margin-bottom: 5px;">
            {{ index + 1 }}.{{ item.waybillNumber }}，{{ item.reason }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { lmLossResponsibilityImport } from '@/api/definiteResponsibilityAndPenalty';

export default {
  props: {
    siteIdList: {
      type: Array,
      default: () => []
    },
    importType: {
      type: Number,
      default: 1
    },
    responsibilityTypeList: {
      type: Object,
      default: () => {}
    },
    branchEnableList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      importDataParam: {
        waybillNumbers: '',
        lossType: 7,
        siteId: ''
      },
      importData: {
        success: 0,
        fail: 0,
        totalCount: 0,
        failList: []
      }
    };
  },
  methods: {
    // 导入
    confirmImport() {
      this.$refs.importDataForm.validate(valid => {
        if (valid) {
          const params = {
            waybillNumberList: [],
            lossType: this.importDataParam.lossType,
            siteId: this.importDataParam.siteId
          };
          const num = this.importDataParam.waybillNumbers.split(/([\n\r])/);
          num.map(item => {
            const reg = /\s/g;
            const a = item.replace(reg, '');
            const b = a.trim();
            if (b) {
              params.waybillNumberList.push(b);
            }
          });
          if (params.waybillNumberList.length > 2000) {
            this.$message.warning(this.$t('fixDutyFine.Only2000PiecesImport'));
            return;
          }
          lmLossResponsibilityImport(params).then(res => {
            if (res.code === 200) {
              this.importData = {
                success: res.data.successCount,
                fail: res.data.failCount,
                totalCount: res.data.totalCount,
                failList: res.data.failReasonList
              };
              this.$emit('confirmImportData');
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
